'use client';

import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { useUtilityClasses } from "./chartsTooltipClasses.js";
import { ChartsTooltipCell, ChartsTooltipMark, ChartsTooltipPaper, ChartsTooltipRow, ChartsTooltipTable } from "./ChartsTooltipTable.js";
import { useAxisTooltip } from "./useAxisTooltip.js";
import { useXAxis, useYAxis } from "../hooks/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ChartsAxisTooltipContent(props) {
  const {
    classes: propClasses,
    sx
  } = props;
  const tooltipData = useAxisTooltip();
  const xAxis = useXAxis();
  const yAxis = useYAxis();
  const classes = useUtilityClasses(propClasses);
  if (tooltipData === null) {
    return null;
  }
  const {
    axisDirection,
    axisValue,
    axisFormattedValue,
    seriesItems
  } = tooltipData;
  const axis = axisDirection === 'x' ? xAxis : yAxis;
  return /*#__PURE__*/_jsx(ChartsTooltipPaper, {
    sx: sx,
    className: classes.paper,
    children: /*#__PURE__*/_jsxs(ChartsTooltipTable, {
      className: classes.table,
      children: [axisValue != null && !axis.hideTooltip && /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsx(ChartsTooltipRow, {
          className: classes.row,
          children: /*#__PURE__*/_jsx(ChartsTooltipCell, {
            colSpan: 3,
            className: clsx(classes.cell, classes.axisValueCell),
            children: /*#__PURE__*/_jsx(Typography, {
              children: axisFormattedValue
            })
          })
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: seriesItems.map(({
          seriesId,
          color,
          formattedValue,
          formattedLabel
        }) => {
          if (formattedValue == null) {
            return null;
          }
          return /*#__PURE__*/_jsxs(ChartsTooltipRow, {
            className: classes.row,
            children: [/*#__PURE__*/_jsx(ChartsTooltipCell, {
              className: clsx(classes.markCell, classes.cell),
              children: color && /*#__PURE__*/_jsx(ChartsTooltipMark, {
                color: color,
                className: classes.mark
              })
            }), /*#__PURE__*/_jsx(ChartsTooltipCell, {
              className: clsx(classes.labelCell, classes.cell),
              children: formattedLabel ? /*#__PURE__*/_jsx(Typography, {
                children: formattedLabel
              }) : null
            }), /*#__PURE__*/_jsx(ChartsTooltipCell, {
              className: clsx(classes.valueCell, classes.cell),
              children: /*#__PURE__*/_jsx(Typography, {
                children: formattedValue
              })
            })]
          }, seriesId);
        })
      })]
    })
  });
}
process.env.NODE_ENV !== "production" ? ChartsAxisTooltipContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChartsAxisTooltipContent };